import { memo } from 'react';
import { Button } from '@/hen-ui/atomics/Button';
import type { SubNavCta } from './types';
import { normalizeNavHref } from './utils';

interface SubNavFooterProps {
  cta: SubNavCta;
  variant?: 'desktop' | 'mobile';
}

export const SubNavFooter = memo(function SubNavFooter({
  cta,
  variant = 'desktop',
}: SubNavFooterProps) {
  const className =
    variant === 'mobile'
      ? 'flex flex-col items-center gap-sm rounded-lg bg-neutral-50 px-lg py-xl text-b4 font-bold text-heading'
      : 'flex flex-col items-center gap-lg border-t border-neutral-200 px-lg py-md text-b4 font-bold text-heading lg:flex-row lg:gap-sm lg:px-xl lg:py-sm lg:text-b5 xl:gap-xl xl:px-2xl xl:py-md xl:text-b3';

  return (
    <div className={className}>
      {cta.text}
      <Button variant='primaryFill' size='sm' href={normalizeNavHref(cta.href)}>
        {cta.buttonText}
      </Button>
    </div>
  );
});
